import React, { Component } from 'react';
import { Button, Icon, withStyles } from '@material-ui/core';
import { CSVLink } from 'react-csv';
import AuthorsTable from './AuthorsTable';

import kinopoisk from '../config/kinopoisk';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  iconSmall: {
    fontSize: 20
  }
});

class Authors extends Component {
  constructUrl = kpid => kinopoisk.mainAuthorUrlPart + kpid.toString();

  constructCsvData = () => [
    ['Никнейм', 'Ссылка на профиль'],
    ...this.props.authors.map(author => [
      author.nickname,
      this.constructUrl(author.kpid)
    ])
  ];

  render() {
    const { classes } = this.props;
    const csvLink = props => (
      <CSVLink
        data={this.constructCsvData()}
        filename={'Авторы конкурсного раздела.csv'}
        target="_blank"
        {...props}
      />
    );
    return (
      // <Card className="full-size">
      //   <CardHeader title="Авторы" />
      //   <CardContent>
      //     <AuthorsTable authors={this.props.authors} />
      //   </CardContent>
      //   <CardActions>
      //     <Button color="primary" variant="contained" component={csvLink}>
      //       <Icon className={classes.leftIcon}>arrow_upward</Icon>
      //       Экспорт в CSV
      //     </Button>
      //   </CardActions>
      // </Card>
      // <Card>
      //   <CardHeader title="Авторы" />
      //   <CardContent>
      //     <AuthorsTable authors={this.props.authors} />
      //   </CardContent>
      //   <CardActions>
      //     <Button color="primary" variant="contained" component={csvLink}>
      //       <Icon className={classes.leftIcon}>arrow_upward</Icon>
      //       Экспорт в CSV
      //     </Button>
      //   </CardActions>
      // </Card>

      <div className="card full-size">
        <h1>Авторы</h1>
        <div>
          <AuthorsTable authors={this.props.authors} />
        </div>
        <div className="card-actions">
          <Button color="primary" variant="contained" component={csvLink}>
            <Icon className={classes.leftIcon}>arrow_upward</Icon>
            Экспорт в CSV
          </Button>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Authors);



// WEBPACK FOOTER //
// ./src/components/Authors.jsx